import React from 'react';
import PropTypes from 'prop-types';
import { SFServices, starfishMediaType } from 'utils/types';
import ServicesView from './ServicesView';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import { InstitutionalService } from './InstitutionalService';

export default class ServicesContainer extends React.Component {

  constructor() {
    super();
    this.state = { hasFetched: false };
  }

  componentDidMount() {
    const URL = `../api/starfish/success-network/services`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(({services}) => this.props.onServicesFetched(services.map(InstitutionalService)))
    .catch(e => this.props.onFailure(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <ServicesView
        hasFetched={this.state.hasFetched}
        services={this.props.services}
        isStudent={this.props.isStudent}
        isStaff={this.props.isStaff}
        isServiceMember={this.props.isServiceMember}
        canSeeStudentServices={this.props.canSeeStudentServices}
        canMakeAppointment={this.props.canMakeAppointment}
        hasConnectLicense={this.props.hasConnectLicense}
        responsiveKioskEnabled={this.props.responsiveKioskEnabled}
        virtualCheckInEnabled={this.props.virtualCheckInEnabled}
      />
    );
  }
}

ServicesContainer.propTypes = {
  services: SFServices.isRequired,
  onServicesFetched: PropTypes.func.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isStaff: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  canSeeStudentServices: PropTypes.bool,
  canMakeAppointment: PropTypes.bool,
  hasConnectLicense: PropTypes.bool,
  onFailure: PropTypes.func.isRequired,
  responsiveKioskEnabled: PropTypes.bool,
  virtualCheckInEnabled: PropTypes.bool
};
